import { useQuery } from '@tanstack/react-query';
import { admin } from '../../api/client.js';
import { DateTime } from '../../components/admin/AdminUI.jsx';

/** Admin action history — new in v2; the old portal recorded nothing. */
export default function AdminAudit() {
  const { data: entries = [], isLoading } = useQuery({
    queryKey: ['admin', 'audit'], queryFn: admin.getAudit
  });

  if (isLoading) return <div className="admin-page"><div className="spinner-border" /></div>;

  return (
    <div className="admin-page">
      <h1 className="h4 mb-3">Audit Log</h1>
      <table className="table table-sm">
        <thead><tr><th>When</th><th>Who</th><th>Action</th><th>Target</th><th>Detail</th></tr></thead>
        <tbody>
          {entries.map(e => (
            <tr key={e.auditId}>
              <td className="text-nowrap small"><DateTime value={e.occurredUtc} fallback="—" /></td>
              <td className="small">{e.actorEmail ?? '—'}</td>
              <td><code className="small">{e.action}</code></td>
              <td className="small">{e.targetType ? `${e.targetType}:${e.targetId}` : '—'}</td>
              <td className="small text-muted">
                {e.detail ? JSON.stringify(e.detail).slice(0, 120) : ''}
              </td>
            </tr>
          ))}
          {entries.length === 0 && (
            <tr><td colSpan={5} className="text-center text-muted py-4">Nothing recorded yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
